import React from "react";
import { useEffect, useState } from "react";
import axios from "axios";
import { Fragment } from "react";
import Select from "react-select";
import Form from 'react-bootstrap/Form';

import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Button } from "react-bootstrap";


function ContactUs(props) {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [subject, setSubject] = useState('Ordering an EZ ICE Rink');
    const [message, setMessage] = useState('');
    const [submitted, setSubmitted] = useState(false);

    async function handleSubmit(event) {
        event.preventDefault();

        const payload = {
            name: name,
            email: email,
            subject: subject,
            message: message
        }

        if (!name || !email || !subject || !message) {
            toast.error("Please fill out all fields before submitting.");
            return;
        }

        try {
            const response = await axios.post("https://ezice.herokuapp.com/api/shopify/submit_contact_form", payload);
            if (response.status < 400) {
                toast.success("Message sent successfully!");
                setSubmitted(true);
            } else {
                toast.error("Failed to send message. Please try again.");
            }
        } catch (error) {
            console.error(error);
            toast.error("Failed to send message. Please try again.");
        }
    }

    return (
        <div className="flex flex-col items-center mx-auto bg-gray-100 p-6 rounded-lg w-full">
            <h1 className="text-4xl font-bold text-center">Contact Us</h1>
            <div className="flex flex-col pt-4">
                <div className="flex justify-between bk1:justify-center bk3:flex-col bk3:items-center">
                    <div className="flex items-center bk3:p-1 bk3:mr-0 bk3m:mr-2 justify-center w-[390px] bk3:w-[350px] bk3m:p-3 bk3m:space-x-4 bk3:space-x-2 border-solid border-2 rounded-xl border-gray-400">
                        <div className="flex flex-col items-center">
                            <div className="flex items-center">
                                <div className="w-5 mr-1">
                                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g id="SVGRepo_bgCarrier" stroke-width="0"/>
                                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/>
                                    <g id="SVGRepo_iconCarrier"> <path d="M9 2C9 1.44772 9.44772 1 10 1H14C14.5523 1 15 1.44772 15 2V3C15 3.55228 14.5523 4 14 4H10C9.44772 4 9 3.55228 9 3V2Z" fill="#4a4a4a"/> <rect x="5.75" y="1.75" width="12.5" height="20.5" rx="1.75" stroke="#4a4a4a" stroke-width="1.5"/> <path d="M9 19.5H15" stroke="#4a4a4a" stroke-width="1.5" stroke-linecap="round"/> </g>
                                </svg>
                                </div>
                                <div className="text-md font-medium text-blue-800"><a className="text-blue-800" href="tel:262-394-2360">(262) 394-2360</a></div>
                            </div>
                            <div className="text-xs text-gray-600">Schedule a free consultation <a class="text-blue-800" target="_blank" href="https://calendly.com/d/2x2-msz-tqr/backyard-rink-expert-consult">HERE</a></div>
                        </div>
                    </div>
                    <div className="bk1:hidden flex items-center mr-2 justify-center w-[390px] bk3:w-[350px] p-3 bk3m:space-x-4 bk3:space-x-2 border-solid border-2 rounded-xl border-gray-400">
                        <div className="flex flex-col items-center">
                            <div className="flex items-center">
                                <div className="w-5 mr-2">
                                    <svg fill="#4a4a4a" viewBox="0 0 395.665 395.665" stroke="#4a4a4a">
                                        <g id="SVGRepo_bgCarrier" stroke-width="0"/>
                                        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/>
                                        <g id="SVGRepo_iconCarrier"> <g> <circle cx="139.731" cy="197.832" r="19.5"/> <circle cx="205.833" cy="197.832" r="19.5"/> <circle cx="271.934" cy="197.832" r="19.5"/> <path d="M338.143,90.964c-35.557-27.021-82.553-41.901-132.326-41.901S109.05,63.943,73.493,90.964 c-37.092,28.187-57.52,66.14-57.52,106.869c0,19.5,4.654,38.322,13.856,56.084l-28.33,66.565 c-2.467,5.798-1.861,12.447,1.615,17.703c3.475,5.256,9.355,8.418,15.656,8.418c0,0,185.973,0,187.047,0 c49.773,0,96.768-14.881,132.326-41.901c37.094-28.187,57.521-66.14,57.521-106.869S375.237,119.15,338.143,90.964z M345.593,237.012c-7.127,13.238-17.773,25.297-31.65,35.84c-28.641,21.764-67.041,33.75-108.125,33.75 c-0.836,0-154.939,0-154.939,0l15.758-37.022l7.377-17.335l-8.666-16.728c-6.219-12.007-9.373-24.686-9.373-37.685 c0-13.58,3.389-26.762,10.072-39.18c7.125-13.238,17.773-25.297,31.648-35.841c28.639-21.763,67.039-33.749,108.123-33.749 c41.086,0,79.486,11.986,108.125,33.749c13.877,10.544,24.523,22.603,31.65,35.841c6.684,12.418,10.072,25.6,10.072,39.18 S352.276,224.594,345.593,237.012z"/> </g> </g>
                                    </svg>
                                </div>
                                <div className="text-md font-medium text-blue-800">Chat With Support</div>
                            </div>
                            <div className="text-xs text-gray-600">Click the chat icon at bottom right</div>
                        </div>
                    </div>
                    <div className="flex items-center bk3:p-1 bk3:mr-0 bk3m:mr-2 justify-center w-[390px] bk3:w-[350px] bk3m:p-3 bk3:mt-2 space-x-4 border-solid border-2 rounded-xl border-gray-400">
                        <div className="flex flex-col items-center">
                            <div className="flex items-center">
                                <div className="w-5 mr-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#4a4a4a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-mail">
                                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                                        <polyline points="22,6 12,13 2,6"/>
                                    </svg>
                                </div>
                                <div className="text-md font-medium text-blue-800"><a className="text-blue-800" href="mailto:customer_experience@ezicerinks.com">customer_experience@ezicerinks.com</a></div>
                            </div>
                            <div className="text-xs text-gray-600">We'll respond as soon as we can</div>
                        </div>
                    </div>
                </div>
                <div className="flex justify-center items-center">
                    <img className="bk3:hidden w-[790px] bk1:w-[400px] bk1:h-[210px] h-[430px] rounded-md" src="https://ezicerinks.com/cdn/shop/files/EZ_ICE_PRO_Home_Arena_System_1600x900_45cf916a-68aa-4883-a760-fc4632362bce.jpg?v=1630506824&width=2048"/>
                    <form className="bg-gray-100 py-4 rounded-lg space-y-4 w-[370px] ml-8 bk3:ml-0">
                        <div className="flex items-center">
                            <div className="flex flex-col">
                                <div className="flex items-center">
                                    <div className="w-5 mr-2">
                                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g id="SVGRepo_bgCarrier" stroke-width="0"/>
                                        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/>
                                        <g id="SVGRepo_iconCarrier"> <g id="Communication / Chat_Dots"> <path id="Vector" d="M5.59961 19.9203L7.12357 18.7012L7.13478 18.6926C7.45249 18.4384 7.61281 18.3101 7.79168 18.2188C7.95216 18.1368 8.12328 18.0771 8.2998 18.0408C8.49877 18 8.70603 18 9.12207 18H17.8031C18.921 18 19.4806 18 19.908 17.7822C20.2843 17.5905 20.5905 17.2842 20.7822 16.9079C21 16.4805 21 15.9215 21 14.8036V7.19691C21 6.07899 21 5.5192 20.7822 5.0918C20.5905 4.71547 20.2837 4.40973 19.9074 4.21799C19.4796 4 18.9203 4 17.8002 4H6.2002C5.08009 4 4.51962 4 4.0918 4.21799C3.71547 4.40973 3.40973 4.71547 3.21799 5.0918C3 5.51962 3 6.08009 3 7.2002V18.6712C3 19.7369 3 20.2696 3.21846 20.5433C3.40845 20.7813 3.69644 20.9198 4.00098 20.9195C4.35115 20.9191 4.76744 20.5861 5.59961 19.9203Z" stroke="#4a4a4a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> </g> </g>
                                    </svg>
                                    </div>
                                    <div className="text-md font-medium text-blue-800">Send Us A Message</div>
                                </div>
                                <div className="text-xs text-gray-600">We'll respond within 24-48 hours</div>
                            </div>
                        </div>
                        <div className="relative">
                            <label for="name" className="block text-gray-700 absolute left-[9px] bottom-[27px] text-xs bg-gray-100 px-2">Name</label>
                            <input type="text" id="name" className="w-full mt-1 p-2 bg-gray-100  border-solid border-2 border-gray-400 rounded-md pl-3" placeholder="Name" onChange={(e) => setName(e.target.value)}/>
                        </div>
                        <div className="relative">
                            <label for="email" className="block text-gray-700 absolute left-[9px] bottom-[27px] text-xs bg-gray-100 px-2">Email</label>
                            <input type="email" id="name" className="w-full mt-1 p-2 bg-gray-100  border-solid border-2 border-gray-400 rounded-md pl-3" placeholder="Email" onChange={(e) => setEmail(e.target.value)}/>
                        </div>
                        <div className="relative">
                            <label for="subject" className="block text-gray-700 absolute left-[9px] bottom-[24px] text-xs bg-gray-100 px-2">Subject</label>
                            <select id="subject" className="w-full mt-1 p-2 bg-gray-100 border-gray-400 border-2 rounded-md cursor-pointer" onChange={(e) => setSubject(e.target.value)}>
                                <option>Ordering an EZ ICE Rink</option>
                                <option>Ordering an EZ Upgrade</option>
                                <option>Shipping & Delivery Questions</option>
                                <option>Assembly Questions</option>
                                <option>Other</option>
                            </select>
                        </div>

                        <div className="relative mb-8">
                            <label for="message" className="block text-gray-700 absolute left-[9px] top-[-4px] text-xs bg-gray-100 px-2">Message</label>
                            <textarea id="message" className="w-full mt-1 p-2 bg-gray-100 border-gray-400 border-2 rounded-md" rows="4" placeholder="What's on your mind?" onChange={(e) => setMessage(e.target.value)}></textarea>
                        </div>

                        {submitted && <div className="text-ezice-blue-600">Message sent successfully!</div>}
                        <button type="submit" className="w-28 bg-ezice-blue-600 text-white py-2 border-gray-300 rounded-md" onClick={handleSubmit}>Submit</button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default ContactUs;
